import { useEffect, useState } from "react";
import styled from 'styled-components';
import axios from 'axios';
import BASE_API_URL from '../../../apis/index';

export default function CompProductSecBulkUploadsSec({ compId, compType }) {
    const [sheets, setSheets] = useState([]);

    useEffect(() => {
        async function fetchBulkSheets() {
            try {
                const authToken = localStorage.getItem("authToken");

                const res = await axios.get(
                    `${BASE_API_URL}/api/admin/company/products/bulksheets/${compId}`,
                    {
                        params: { company_type: compType },
                        headers: { Authorization: `Bearer ${authToken}` },
                    }
                );

                setSheets(res.data.result || []);
            } catch (err) {
                console.error(err);
            }
        }

        fetchBulkSheets();
    }, [compId, compType]);

    if (sheets.length === 0) {
        return <p>No bulk uploads found.</p>;
    }

    return (
        <BulkUploadsSecWrapper>

            {sheets.map((sheet, index) => {
                const formattedDate = new Date(sheet.upload_time).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                });

                return (
                    <div key={sheet.id} className="sheetCard">

                        {/* LEFT */}
                        <div className="sheetInfo">
                            <p className="sheetDate">
                                📅 <strong>Date:</strong> {formattedDate}
                            </p>

                            <p className="sheetProducts">
                                📦 <strong>Products:</strong> {sheet.total_products}
                            </p>

                            <p className="sheetNumber">
                                🧾 <strong>Sheet ID:</strong> {sheet.sheet_number}
                            </p>
                        </div>

                        {/* RIGHT */}
                        <div className="sheetActions">
                            <button
                                className="downloadBtn"
                                onClick={() => {
                                    const fixedPath = sheet.file_path.replace(/\\/g, "/");
                                    window.open(`${BASE_API_URL}/${fixedPath}`, "_blank");
                                }}
                            >
                                ⬇ Download Sheet
                            </button>
                        </div>

                    </div>
                );
            })}

        </BulkUploadsSecWrapper>
    );
}

const BulkUploadsSecWrapper = styled.div`
.sheetCard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 14px;
  background: #fff;
  transition: 0.2s;
}

.sheetCard:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.sheetInfo p {
  margin: 4px 0;
  font-size: 14px;
  color: #444;
}

.sheetDate {
  font-weight: 500;
}

.sheetProducts {
  color: #666;
}

.sheetNumber {
  font-size: 13px;
  color: #888;
}

.downloadBtn {
  background: #f7931e;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: 0.2s;
}

.downloadBtn:hover {
  background: #e67e00;
}
`